module.exports = __webpack_public_path__ + "img/SKT.ab12d416.png";